/**
 * Fly pattern definitions
 *
 * Each fly pattern targets specific species groups with weighted preferences.
 * Fly patterns are consumed like bait and occupy the BAIT equipment slot.
 * They only work when a fly rod is equipped.
 */

import { FishRarity, type FlyPatternDefinition } from '@/types';

export const FLY_PATTERN_DATA: Record<string, FlyPatternDefinition> = {
  pattern_adams: {
    id: 'pattern_adams',
    name: 'Adams Dry Fly',
    description: 'A classic trout pattern that imitates a variety of mayflies.',
    icon: '🪶',
    targetSpecies: ['brook_trout', 'cutthroat_trout', 'trout', 'brown_trout'],
    targetWeightMultiplier: 2.5,
  },
  pattern_woolly_bugger: {
    id: 'pattern_woolly_bugger',
    name: 'Woolly Bugger',
    description: 'An aggressive streamer that draws strikes from predatory fish.',
    icon: '🪶',
    targetSpecies: ['bass', 'brown_trout', 'tiger_trout', 'cuttbow_trout'],
    targetWeightMultiplier: 2.0,
  },
  pattern_elk_hair_caddis: {
    id: 'pattern_elk_hair_caddis',
    name: 'Elk Hair Caddis',
    description: 'A versatile surface fly attractive to panfish and trout alike.',
    icon: '🪶',
    targetSpecies: ['bluegill', 'perch', 'brook_trout', 'cutthroat_trout'],
    targetWeightMultiplier: 2.5,
  },
  pattern_royal_wulff: {
    id: 'pattern_royal_wulff',
    name: 'Royal Wulff',
    description: 'A high-visibility attractor that draws rare species to the surface.',
    icon: '🪶',
    targetSpecies: ['arctic_grayling', 'tiger_trout', 'cuttbow_trout', 'brown_trout'],
    targetWeightMultiplier: 3.0,
    minRarity: FishRarity.UNCOMMON,
  },
};

/**
 * Get fly pattern definition by ID
 */
export function getFlyPatternDefinition(id: string): FlyPatternDefinition | undefined {
  return FLY_PATTERN_DATA[id];
}

/**
 * Get all fly pattern definitions
 */
export function getAllFlyPatterns(): FlyPatternDefinition[] {
  return Object.values(FLY_PATTERN_DATA);
}
